import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { ToastrService } from 'ngx-toastr'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ParametreDto } from '../../../data-access/http/dto/parametre-dto'
import { ParametreService } from '../../../data-access/http/parametre.service'
import { NotificationService } from '../../../data-access/http/notification.service'
import { SunleonService } from 'src/app/sunleon/data-access/http/sunleon.service'

@Component({
  selector: 'app-parametre-booleen-modal',
  templateUrl: './parametre-booleen-modal.component.html',
  styleUrls: ['./parametre-booleen-modal.component.scss']
})
export class ParametreBooleenModalComponent implements OnInit {

  @Input()
    parametre: ParametreDto
    overloadable: boolean
    control: FormControl
    formModalIsSubmitting: boolean = false
  
    @ViewChild('inputValeur') inputValeur: ElementRef;
    @ViewChild('close') public modal: ParametreBooleenModalComponent;
  
    constructor(
      private toastr: ToastrService,
      private parametreService: ParametreService,
      private activeModal: NgbActiveModal,
      private notificationService: NotificationService
    ) {}
  
    ngOnInit(): void {
      this.control = new FormControl(this.parametre.valeur);
    }
    
    onSubmit(): void {
      this.formModalIsSubmitting = true
      const oldValue = this.parametre.valeur
  
      this.parametreService.saveParametreTypeSimple(this.parametre, this.control.value).subscribe({
        next:(data: any) => {
          const notif = this.notificationService.createNotification(this.parametre.id, this.parametre.code, this.parametre.type, oldValue, this.parametre.valeur)
          notif.subscribe({
            next: () => {},
            error: () => {
              this.toastr.error("Erreur lors de la création de la notification")
            },
          })
          this.toastr.success('Le paramètre ' + this.parametre.code + ' a été enregistré avec succès.')
              this.formModalIsSubmitting = false
              this.activeModal.dismiss(data)
        },
        error:() => {
          this.toastr.error('Erreur lors de l\'enregistrement du paramètre.')
          this.formModalIsSubmitting = false
          this.activeModal.dismiss()
        }}
      )
    }
  
    fermerModal(): void {
      this.activeModal.dismiss()
    }
  
  }
  
